import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ScrollText } from "lucide-react";

export const DISCLAIMER_TEXT = `Ocean Ash acts solely as a platform to advertise, promote, and facilitate job opportunities between employers and prospective workers. While Ocean Ash may review and approve job listings and who can recruit before publication, we do not employ, supervise, manage, or control the individuals or businesses offering or undertaking the work. All employers, contractors, agencies, and workers listed through Ocean Ash are independently responsible for ensuring that they comply with all applicable laws, regulations, licensing requirements, health and safety obligations, tax requirements, and employment legislation relevant to their activities. Ocean Ash does not accept any responsibility or liability for the actions, omissions, conduct, performance, compliance, or legal obligations of any employer, worker, contractor, or third party using our platform. Any agreement, contract, or working relationship entered into between parties is solely between those parties. By using our services, all users acknowledge and agree that they are responsible for conducting their own due diligence and for complying with all legal and regulatory requirements applicable to their circumstances.`;

export default function Disclaimer() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
      <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold hover:text-[var(--brand-primary)]">
        <ArrowLeft className="w-4 h-4" /> Home
      </Link>
      <div className="mt-8">
        <div className="label-eyebrow flex items-center gap-1.5"><ScrollText className="w-3 h-3 text-[var(--brand-primary)]" /> Legal</div>
        <h1 className="font-display font-black text-5xl tracking-tight mt-3">Platform Disclaimer.</h1>
      </div>
      <article className="mt-10 text-base leading-relaxed text-[#3a3a3a] whitespace-pre-wrap" data-testid="disclaimer-text">
        {DISCLAIMER_TEXT}
      </article>
      <div className="mt-10 border border-[#0F0F0F] p-5">
        <div className="label-eyebrow">Full legal policies</div>
        <p className="text-sm text-[#5C5C5C] mt-1">For our complete privacy policy, terms of service, GDPR records, and compliance statements, visit our legal centre:</p>
        <a
          href="https://legal.oceanash.org"
          target="_blank"
          rel="noreferrer"
          data-testid="legal-centre-link"
          className="inline-flex items-center gap-1.5 mt-3 font-display font-bold text-sm hover:text-[var(--brand-primary)]"
        >
          legal.oceanash.org →
        </a>
      </div>
      <p className="mt-8 text-xs text-[#5C5C5C]">
        Last updated: {new Date().toISOString().slice(0, 10)}. For questions, contact <a className="underline hover:text-[var(--brand-primary)]" href="mailto:admin@oceanash.org">admin@oceanash.org</a>.
      </p>
    </div>
  );
}
